module.exports = __webpack_public_path__ + "d1e88ba63de72ab6bd9166906eba25e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Assets/partyFoods.png
// module id = 1323
// module chunks = 0